export enum RoleNames {
    admin = 'ADMIN',
    backOffice = 'BACKOFFICE',
    caregiver = 'CAREGIVER',
    professional = 'PROFESSIONAL',
}
